import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { kpiRoutes } from './kpiRoutes';
import { LibraryPage } from './LibraryPage';
import { CompanyStatusPage } from './CompanyStatusPage';
import { TemplatesPage } from './TemplatesPage';
import { DataEntryPage } from './DataEntryPage';
import { useLibrary } from './hooks/useLibrary';

export const KPIRouter = (props: any) => {
  const { baseRoute } = props;
  const { operations } = useLibrary();
  useEffect(() => {
    operations.loadKPIs().then();
  }, []);

  return (
    <Switch>
      <Route path={baseRoute + kpiRoutes.Library}>
        <LibraryPage />
      </Route>
      <Route path={baseRoute + kpiRoutes.CompanyStatus}>
        <CompanyStatusPage />
      </Route>
      <Route path={baseRoute + kpiRoutes.Templates}>
        <TemplatesPage />
      </Route>
      <Route path={baseRoute + kpiRoutes.DataEntry}>
        <DataEntryPage />
      </Route>
      <Route path={baseRoute + kpiRoutes.DataEntryRoot}>
        <DataEntryPage />
      </Route>
      <Route path="*">
        <Redirect to={baseRoute + kpiRoutes.Library} />
      </Route>
    </Switch>
  );
};
